import React, { Component } from 'react';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import GuestNavbar from '../navigation/guestnavbar.jsx';
import TermsNCond from './TermsApi.jsx';
class termsandConditionMain extends Component {
    render() {
        return (
            <div>
            {localStorage.getItem("loginState") === "true" ?
                <div className="row" >
                    <div className="col-sm-12 m-0 p-0">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{ }}>
                        <div className="row">
                            {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                <LeftLink />
                            </div> */}
                            <div className="col-sm-12" style={{ }}>

                                <div className="row " style={{ minHeight: "476px" }}>
                                    <TermsNCond />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <div className="col-sm-12">
                        <GuestNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <TermsNCond />
                        </div>
                    </div>
                </div>}
        </div>
        );
    }
}

export default termsandConditionMain;


// WEBPACK FOOTER //
// ./src/components/termsandcondition/termsandconditionmain.jsx